import { Component, input, output } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { Button } from 'excellence-ui';

@Component({
  selector: 'app-error-component',
  imports: [NgIcon, Button, TranslocoPipe],
  templateUrl: './error-component.html',
})
export class ErrorComponent {
  enableRetry = input<boolean>(false);

  clickRetry = output<void>();
}
